import {useState} from 'react';
import cx from 'classnames';

import {Text} from '#component/base';
import {Hero} from '#component/partial';
import {pageSlideInKeyframe} from '#style/keyframes.css';
import {sprinkles} from '#style/sprinkles';

import {tips} from './Header.util';

import {HeaderProps} from './Header.types';

export const Header = ({firstName}: HeaderProps) => {
  const [tip] = useState(tips[Math.floor(Math.random() * tips.length)]);

  return (
    <Hero>
      <div
        className={cx(
          sprinkles({layout: 'grid', pB: [80, 80, 192], pT: [80, 128]}),
          pageSlideInKeyframe,
        )}>
        <Text
          className={sprinkles({
            flex: ['auto', 'flex'],
            dir: 'col',
            colSpan: [4, 6, 5],
            colStart: [1, 2],
          })}
          color="inherit"
          variant="heading1">
          <span>{'Welcome back, '}</span>
          <span>{firstName || 'user'}</span>
        </Text>

        <div
          className={sprinkles({
            colSpan: [4, 6, 5],
            colStart: [1, 2, 7],
            dir: 'col',
            flex: 'flex',
            gap: 24,
            pT: [40, 40, 0],
          })}>
          <Text color="inherit" variant="label">
            Did you know?
          </Text>

          <Text color="inherit" variant="bodyLarge">
            {tip}
          </Text>
        </div>
      </div>
    </Hero>
  );
};
